import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'das-diary-warning-card',
  templateUrl: './diary-warning-card.component.html',
  styleUrls: ['./diary-warning-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiaryWarningCardComponent {
  public readonly warningText: string =
    'When this departure application was migrated from DAS 2.0, inconsistencies were found' +
    ' within the associated diary entries. To ensure that the diary can be shown correctly within DAS 3.0, some' +
    ' dates have been estimated. The "Specialist Review" section may provide further information' +
    ' otherwise please contact the DAS Admin team for assistance if required.';
}
